import { render, staticRenderFns } from "./PanelLoading.vue?vue&type=template&id=35b36fb4&scoped=true&"
import script from "./PanelLoading.vue?vue&type=script&lang=js&"
export * from "./PanelLoading.vue?vue&type=script&lang=js&"
import style0 from "./PanelLoading.vue?vue&type=style&index=0&id=35b36fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b36fb4",
  null
  
)

export default component.exports